import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const maximumFileSize = 32;
/** Due to current Google Infrastructure maximum file size upload is 31mb */
export const fileSizeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.value) {
    const fileSize = control.value.split(' ')[0];
    const fileMeasure = control.value.split(' ')[1];
    if (fileSize && fileMeasure == 'MB' && Number(fileSize) > 31) {
      return { fileSize: true };
    }
  } else {
    return null;
  }
};
